import { createContext, useContext, useState, useCallback } from "react";
import NotificationStack from "../components/Notification";
import { v4 as uuidv4 } from "uuid";

const NotificationContext = createContext();

export const NotificationProvider = ({ children }) => {
  const [notifications, setNotifications] = useState([]);

  // ✅ Show new notification
  const showNotification = useCallback(
    ({ type = "info", title = "", message = "", duration = 4000 }) => {
      const id = uuidv4();
      const newNote = { id, type, title, message };
      setNotifications((prev) => [newNote, ...prev]); // new ones stack on top

      // auto-dismiss after duration
      setTimeout(() => {
        setNotifications((prev) => prev.filter((n) => n.id !== id));
      }, duration);
    },
    []
  );

  // ✅ Manually close
  const closeNotification = useCallback((id) => {
    setNotifications((prev) => prev.filter((n) => n.id !== id));
  }, []);

  return (
    <NotificationContext.Provider value={{ showNotification }}>
      {children}
      <NotificationStack
        notifications={notifications}
        onClose={closeNotification}
      />
    </NotificationContext.Provider>
  );
};

export const useNotification = () => useContext(NotificationContext);
